import * as React from 'react';
import {
  TableRow,
  TableCell,
  Typography,
  makeStyles,
  Theme,
  DefaultButton,
} from '@bb-ui/react-library';
import { useTranslation } from 'react-i18next';
import { formatDate } from 'utils/date';
import { StatusChip } from '../shared/index';
import { CohortDetail } from 'App.types';

const useStyles = makeStyles((theme: Theme) => ({
  chipCell: {
    padding: theme.spacing(1, 2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '56px',
  },
  cellText: {
    padding: theme.spacing(0, 2),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    height: '56px',
  },
}));

export interface CohortRowProps {
  cohort: CohortDetail;
  index: number;
  rowClass: string;
  cellTextClass: string;
  onView: () => void;
}

const CohortRow: React.FC<CohortRowProps> = ({ cohort, index, rowClass, onView }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <TableRow className={rowClass} data-testid={`cohort-row-${index}`}>
      <TableCell className={classes.cellText}>
        <Typography variant="body1">{cohort.name}</Typography>
      </TableCell>
      <TableCell align="center" className={classes.chipCell}>
        <StatusChip
          status={cohort.migration_status}
          enableNotifications={cohort.enable_notifications}
        />
      </TableCell>
      <TableCell align="center" className={classes.cellText}>
        <Typography variant="body1">{cohort.created_by_user}</Typography>
      </TableCell>
      <TableCell align="center" className={classes.cellText}>
        <Typography variant="body1">
          {cohort.downtime_date ? formatDate(new Date(cohort.downtime_date)) : '-'}
        </Typography>
      </TableCell>
      <TableCell align="center" className={classes.cellText}>
        <Typography variant="body1">{cohort.sites_count}</Typography>
      </TableCell>
      <TableCell align="center" className={classes.cellText}>
        <DefaultButton onClick={onView}>{t('cohorts.view')}</DefaultButton>
      </TableCell>
    </TableRow>
  );
};

export default CohortRow;
